import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { archLevel } from 'src/data/config';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const sqConfirmationLetterApi = createApi({
  baseQuery,
  reducerPath: 'sqConfirmationLatterApi',
  endpoints: builder => ({
    getSqConfrimationLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.sqConfirmationLatter.getAll
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getSqPublishConfrimationLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.sqConfirmationLatter.getPublishAll
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    selectSqConfrimationLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country, sq_visit_id }) => ({
        url: `${formatString(
          endPoints.sqConfirmationLatter.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
          // ${study_id !== null ? `&study_id=${study_id}` : ''}
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }${sq_visit_id !== null || sq_visit_id !== undefined ? `&sq_visit_id=${sq_visit_id}` : ''}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateSqConfrimationLetter: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data }) => ({
        url: `${formatString(
          endPoints.sqConfirmationLatter.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    signSqConfrimationLetter: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, sq_visit_id }) => ({
        url: `${formatString(
          endPoints.sqConfirmationLatter.sign,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }&sq_visit_id=${sq_visit_id}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    publishSqConfrimationLetter: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        application,
        sq_visit_id,
        publish_doc_version,
        time_zone_id,
        is_published_etmf,
        update
      }) => ({
        url: `${formatString(
          endPoints.sqConfirmationLatter.publish,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }&sq_visit_id=${sq_visit_id}&publish_doc_version=${publish_doc_version}&time_zone_id=${time_zone_id}&is_published_etmf=${is_published_etmf}&update=${update}`,
        method: 'POST'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createNewVersion: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, application_section, sq_visit_id }) => ({
        url: `${formatString(
          endPoints.sqConfirmationLatter.createNewVersion,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.sq_visit_id, value: sq_visit_id }
        )}?country=${country}&&application=${application}&application_section=${application_section}&application_module_section=STUDY LOGS`,
        method: 'POST'
      })
    })
  })
});

export const {
  useLazyGetSqConfrimationLetterQuery,
  useLazyGetSqPublishConfrimationLetterQuery,
  useLazySelectSqConfrimationLetterQuery,
  useUpdateSqConfrimationLetterMutation,
  useSignSqConfrimationLetterMutation,
  usePublishSqConfrimationLetterMutation,
  useCreateNewVersionMutation
} = sqConfirmationLetterApi;
